import { render, staticRenderFns } from "./Destinatarios.vue?vue&type=template&id=01d5da16&"
import script from "./Destinatarios.vue?vue&type=script&lang=js&"
export * from "./Destinatarios.vue?vue&type=script&lang=js&"
import style0 from "./Destinatarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports